import React from "react";
import { Typography } from "@optimizely/axiom";
import { UserPermissionsForm } from "../../components/UserPermissionsForm/UserPermissionsForm";

export const UserPermissions = () => {
    return (
        <div className="width--6-12">
            <div className="push-double--top push-double--bottom">
                <Typography type="header1" className="push-triple--top">
                    User Permissions
                </Typography>
            </div>
            <Typography type="body">Use this form to view all of the permissions assigned to a user.</Typography>
            <UserPermissionsForm />
        </div>
    );
};

UserPermissions.displayName = "UserPermissionsPage";
